// extracted by mini-css-extract-plugin
export default {"tooltip":"XS-z","arrow":"YS-z"};